// window.addEventListener('DOMContentLoaded', function() {});
$(function () {
  function renderFaqs() {
    var $faqs = $('div.prodFaq')
    if (!$faqs[0]) return
    $faqs.each(function (i, ele) {
      var $faq = $(ele)
      var faqs = $faq.data('faqs')
      var paging = $faq.data('paging')
      var type = $faq.data('type') // faqs_show_categories
      var $pagenav = $faq.find('.pagenav')
      var obj = faqs.reduce(function (prev, next) {
        var key = next.category_name || ''
        if (!key) return prev
        prev[key] = (prev[key] || []).concat(next)
        return prev
      }, {})
      var types = Object.keys(obj)
      var rows = obj[type] || faqs
      var $tmpl = $faq.find('script[type="text/template"]')
      var render = function () {
        var template = function (data) {
          $faq.find('.items').html($.tmpl($tmpl, { faqs: data, paging: paging }))
        }
        if (!paging) return template(rows)
        $pagenav.pagination({
          dataSource: rows,
          pageSize: $faq.data('pagesize'),
          callback: function (data, pagination) {
            template(data)
          },
        })
      }
      $faq.on('click', '.list .nav li', function (e) {
        var $this = $(this)
        type = $this.data('type')
        rows = obj[type] || faqs
        $this.addClass('active').siblings().removeClass('active')
        render()
      })
      $faq.on('click', '.items dl', function (e) {
        if (paging) return
        $(this).addClass('cur').siblings().removeClass('cur')
      })
      render()
    })
  }
  renderFaqs()
  // for admin
  document.addEventListener('shopify:section:load', function (evt) {
    var container = $('[data-section-id]', evt.target)[0]
    // console.warn(1111, this, evt, container)
    if (!container) return
    renderFaqs()
  })
})
